import { useEffect, useState } from "react";
import axios from "axios";
import { DateTime } from "luxon";

// Some legacy rows store "null"/"undefined" as a literal string (sometimes
// with stray whitespace) instead of a real null - filter those out too.
function clean(value) {
    if (!value) return "";
    const trimmed = String(value).trim();
    const lower = trimmed.toLowerCase();
    return lower && lower !== "null" && lower !== "undefined" ? trimmed : "";
}

function displayName(user) {
    return (clean(user.name) + " " + clean(user.surname)).trim() || clean(user.username) || "Telegram #" + user.id;
}

export default function TelegramUsersWidget() {
    const [users, setUsers] = useState([]);
    const [status, setStatus] = useState("loading");

    useEffect(() => {
        axios.get("/api/last-chats", { withCredentials: true })
            .then((response) => {
                setUsers(response.data || []);
                setStatus("done");
            })
            .catch(() => setStatus("error"));
    }, []);

    return (
        <div className="conv-dashboard-section">
            <div className="conv-dashboard-section-header">
                <h4 className="conv-dashboard-section-title">Користувачі Telegram</h4>
                <span className="conv-dashboard-link">{users.length}</span>
            </div>

            {status === "loading" ? <p className="conv-dashboard-empty">Завантаження...</p> : ""}
            {status === "error" ? <p className="conv-dashboard-empty">Не вдалося завантажити</p> : ""}
            {status === "done" && users.length === 0 ? <p className="conv-dashboard-empty">Ще ніхто не писав боту</p> : ""}

            {status === "done" && users.length > 0 ? (
                <ul className="conv-participants-list">
                    {users.map((user) => (
                        <li className="conv-participant-row" key={user.id}>
                            <span className="conv-participant-avatar">{displayName(user).charAt(0).toUpperCase()}</span>
                            <span className="conv-participant-name">{displayName(user)}</span>
                            {user.username ? <span className="conv-tile-tag">@{clean(user.username)}</span> : ""}
                            {user.hasUnread ? <span className="conv-participant-status pending">Нове</span> : ""}
                            <span className="conv-participant-date">
                                {user.dMod ? DateTime.fromISO(user.dMod, { setZone: true }).toFormat("dd.MM.yyyy HH:mm") : ""}
                            </span>
                        </li>
                    ))}
                </ul>
            ) : ""}
        </div>
    );
}
